import { render, staticRenderFns } from "./valuta-casa.vue?vue&type=template&id=64bd0a4a"
import script from "./valuta-casa.vue?vue&type=script&lang=js"
export * from "./valuta-casa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports